// extracted by mini-css-extract-plugin
export default {"card":"ProFeaturesCard_card__u4Sej","grid":"ProFeaturesCard_grid__lSWES","item":"ProFeaturesCard_item__te+vb","icon":"ProFeaturesCard_icon__LaM+Z"};